module.exports = __webpack_public_path__ + "static/media/cyberpanel.1a33c5a4.svg";